<template>
  <b-modal ref="modal" centered @hidden="cancelModal" modal-class="modal-condensed" size="xl" hide-footer>
    <template slot="modal-header">
      <h1>{{ Translations.sections.boxes.sectionTitle }}</h1>
      <div>
        <Button :empty="true" class="close-popup" @click.prevent="cancelModal">{{ Translations.buttons.cancel }}</Button>
        <Button :empty="true" :noBorder="true" color="#d2d2d2" class="validate" @click.prevent="validate">Done</Button>
      </div>
    </template>

    <template>
      <div class="search-container">
        <div class="search-content">
          <div id="station-source" class="source-column">
            <ul>
              <li class="header">
                <h4>
                  <input type="text" placeholder="Stations" class="input" v-model="searchStation">
                </h4>
              </li>
        
              <li :class="['station-source', {'active':activeStation && activeStation.uid === station.uid}]" v-for="station in filteredList" :key="station.uid" @click.prevent="activateStation(station)" >
                <span>{{station.name}}<span class="badge">{{ getLabelName(station.labelCategoryID) }}</span></span>
              </li>
            </ul>
          </div>
          <div id="box-source" class="source-column">
            <ul v-if="activeStation">
              <li class="header">
                <h4>Boxes</h4>
              </li>
              <li :class="['box-source', {'active':(selectedBoxes[box.uid]||{}).uid == box.uid}]" v-for="box in stationMusicBoxes" :key="box.uid" @click.prevent="toggleBox(box)">
                <span class="box-source-wrapper">
                  <i class="fas fa-check"></i>
                  {{cleanBoxesName(box.name)}}
                </span>
              </li>
            </ul>
          </div>
          <div id="box-sourceP" class="source-column" >
            <ul>
              <li class="header">
                <h4>
                  Playlists
                </h4>
              </li>
              <li :class="['box-source', {'active':(selectedBoxes[box.uid]||{}).uid == box.uid}]" v-for="box in stationMusicPlaylist" :key="box.uid" @click.prevent="toggleBox(box)">
                          <span class="box-source-wrapper">
                            <i class="fas fa-check"></i>
                            {{cleanBoxesName(box.name)}}
                          </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>

    <template >
      <hr>
      <div style="padding:25px"  class="selection-container">
        <template v-if="selectedBoxes && Object.keys(selectedBoxes).length">
            <header style="padding-bottom:20px" >Selected items :</header>
            <section>
                 <div class="badge" v-for="item in selectedBoxes">
                   <span class="name">
<!--                     <span v-if="item.station">{{item.station.name}} - </span>-->
                     {{item.name}}</span>
                   <span class="selector">
                      &nbsp;&nbsp; <i class="fas fa-trash" @click.prevent="remove(item)"></i>
                   </span>
                 </div>
            </section>
        </template>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import Button from'@/components/common/Button';
  import Bootstrap from 'bootstrap-vue';
  import Translations from '@/store/translations';
  import Portlet from '@/components/common/Portlet.vue';
  import { HTTP } from '@/utils/http';
  import Apis from '@/apis/index';
  import { mapState } from 'vuex';
  import WaitingBlock from'@/components/common/WaitingBlock';
  import Constants from "@/store/constants";
  import {safeObj} from "@/utils/safeObj";
  import Vue from 'vue'

  export default {
    name: 'SelectorBoxes',
    components: { Portlet, Bootstrap, Button, WaitingBlock },
    computed: {
      Translations: () => Translations,
      stationMusicBoxes() {
        if (!this.activeStation) return [];
        if (!this.stationBoxes) return [];
        // allow only music boxes
        return ((this.stationBoxes[this.activeStation.uid] || {}).items || [])
        .filter(
          itm =>
            (itm.type === Constants.boxTypes.BOX.key ||
              itm.type === Constants.boxTypes.BOX.value) &&
            (itm.trackType === Constants.trackTypes.MUSIC.key ||
              itm.trackType === Constants.trackTypes.MUSIC.value ||
                itm.trackType === Constants.trackTypes.JINGLE.key ||
                itm.trackType === Constants.trackTypes.JINGLE.value
            )
        )
        // .sort(function(a, b) {
        //   return (a.name || "").localeCompare(b.name);
        // });
      },
      filteredList() {
        return safeObj(this.stations) && this.stations.items.filter(station => {
          if(this.searchStation.length === 0) return station
          return station.name.toLowerCase().includes(this.searchStation.toLowerCase())
        })
      },
      stationMusicPlaylist() {
        if (!this.activeStation) return [];
        if (!this.stationBoxes) return [];
        // allow only music boxes
        return ((this.stationBoxes[this.activeStation.uid] || {}).items || [])
            .filter(
                itm =>
                    (itm.type === Constants.boxTypes.PLAYLIST.key ||
                        itm.type === Constants.boxTypes.PLAYLIST.value)
            )
            .sort(function(a, b) {
              return (a.name || "").localeCompare(b.name);
            });
      },
    },
    watch: {
      stationMusicBoxes: {
        handler: function (newData) {
          // save selected boxes to a further using
          this.$store.commit('Boxes/SAVE_SELECTED_BOXES', newData)
        }
      }
    },
    props: {
      stationUid: { required: true },
      noModalEdit: null,
    },
    mounted() {
      this.loadStations();
    },
    data() {
      return {
        modalState: {
          hasSearchProcessed: false,
          isCreationActive: false,
          isLoadingArtists: false,
          delayedSearch: null
        },
        isSearchActive: false,
        activeStation: null,
        stations: [],
        stationBoxes: {},
        selectedBoxes: {},
        searchStation: ''
      };
    },
    methods: {
      cleanBoxesName(value){

        let bName = value
        if(bName.indexOf(":") !== -1 ){
          bName =  bName.slice(1+bName.indexOf(":") , bName.length)
        }if(bName.indexOf(":") !== -1 ){
          bName =  bName.slice(1+bName.indexOf(":") , bName.length)
        }if(bName.indexOf(":") !== -1 ){
          bName =  bName.slice(1+bName.indexOf(":") , bName.length)
        }
        return bName
      },
      remove(item){
        const keys = Object.keys(this.selectedBoxes)
        if (keys.includes(item.uid.toString())) {
          Vue.delete(this.selectedBoxes, item.uid);
        }
      },
      // ------------------------------------------------------
      /* Start : Common Behaviour                            */
      // ------------------------------------------------------
      show() {
        this.$refs.modal.show();
      },
      hide() {
        this.$refs.modal.hide();
      },
      edit(boxes) {
        this.selectedBoxes = boxes && boxes.reduce((acc, item) => {
          if(item.stationID){
            item.station = {name : this.stations.items.filter(tr => tr.id === item.stationID)[0].name};
          }

          acc[item.uid] = item;
          return acc;
        }, {});
        this.show();
      },
      cancelModal() {
       // this.selectedBoxes = null;
        this.$emit("onHidden");
        this.$refs['modal'].hide();
      },
      validate() {
        this.$emit('newValue', 'boxes', Object.values(this.selectedBoxes));
        this.hide();
      },
      // Load Stations
      async loadStations() {
        var response = await HTTP.get(Apis.station.list, {params:{pageSize:10000}});
        if (response.data.dataItem) {
          this.stations = response.data.dataItem;
          if (this.stations.items && this.stations.items.length > 0) {
            var activateStation = this.stations.items
                                      .find(station => station.uid.localeCompare(this.stationUid)==0)
                                  || this.stations.items[0]
            if (activateStation) {
              this.activateStation(activateStation);
            }
          }
        }
      },
      // Load StationBox
      activateStation(station) {
        this.activeStation = station;
        this.loadStationsBox(station.uid);
      },
      toggleBox(box) {
        let selectBox = box;
        if(selectBox.name.indexOf(":") === -1 ){
          if(selectBox.station){
            selectBox.name = selectBox.station.name +' : '+selectBox.name;
          }else{
            selectBox.name =  this.stations.items.filter(tr => tr.uid === selectBox.stationUid)[0].name +' : '+ selectBox.name;
          }
        }


        if (this.selectedBoxes[selectBox.uid]) {
          this.$set(this.selectedBoxes, selectBox.uid, null);
          delete this.selectedBoxes[selectBox.uid];
        } else {
          selectBox.station = this.activeStation;
          if(Object.values(this.selectedBoxes).length === 0)
          {
            this.selectedBoxes = {
              [selectBox.uid]: {...selectBox}
            }
          } else {
            this.$set(this.selectedBoxes, selectBox.uid, selectBox);
          }
        }
      },
      async loadStationsBox(stationUid) {
        var response = await HTTP.get(Apis.boxes.search, {
          params: {
            RadioUid: stationUid,
            sortField: "name",
            sortAscending: true,
            pageSize: 1000,
            page: 0
          }
        });

        if (response.data.dataItem) {
          this.$set(this.stationBoxes, stationUid, response.data.dataItem);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

h4 {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.7px;
  line-height: 1;
  margin:0;padding:0;
}


.search-container {
  overflow: hidden;
  height: 100%;
  height:400px;
  display:flex;
  flex-direction:column;
  flex-grow: 1;
  justify-content: stretch;
  align-self: flex-start;
  ul{
    height: 100%;
    overflow: auto;
    input{
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.7px;
      line-height: 1;
    }
    li {
      span{
        font-weight:600;
        font-size:12px
      }
      span.badge {
        font-weight:400;
        font-size:10px
      }
    }
  }
}

.box-source-wrapper {
  position: relative;
  padding-left: 25px;

  i {
    position: absolute;
    left: 0;
    top: 5px;
  }
}

.search-container .search-content {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  flex-shrink: 0;
  height: 100%;
}

.source-column li.header {
  position: sticky;
  top: 0;
  background:#fff;
  z-index:100;
  padding: 10px;
  border-bottom: 1px solid #dee2e6;
  height:41px;
  display:flex;
  align-items: center;
}

#station-source.source-column {
  width: 50%;
  flex-shrink: 0;
  border-right: 1px solid #dee2e6;
}

#box-source.source-column {
  width: 70%;
  height: 100%;
  overflow: auto;
}
#box-sourceP.source-column {
  width: 70%;
  height: 100%;
  overflow: auto;
}
.search-container header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 10px 15px;
  border-bottom: var(--COLOR_BORDERS) 1px solid;
}

.search-container header h4 {
  margin: 0;
}

.source-column li {
  height: auto;
  padding: 7px 10px;
  align-items: baseline;
}

.source-column li i {
  margin-right: 15px;
}

.source-column li i:hover {
  margin-right: 15px;
  color: var(--COLOR_BRAND);
}



.source-column li .station-label {
  font-size: 12px;
  font-weight: 600;
}

.source-column li i.fa-check {
  opacity: 0.1;
  transition: color 0.2s ease-in-out;
}

.source-column li.active i.fa-check {
  opacity: 1;
  color: var(--COLOR_BRAND);
}
  .source-column{
    li {
      .input{
        width: 100%;
      }
    }
  }
.selection-container {
  background: white;
  max-height: 150px;
  overflow-y: auto;
  display: block;
  box-shadow: 0 -5px 5px -5px white;
  width: 100%;
}

.selection-container header {
  position: sticky;
  top: 0px;
  font-weight: 600;
  font-size: 13px;
  text-decoration: underline;
  background: white;
  padding: 10px 0;
}

.selection-container section {
  padding: 0 0;
  display: flex;
  flex-wrap: wrap;
}

.selection-container .badge {
  border-radius: 100px;
  display: inline-flex;
  padding: 5px 10px;
  color: white;
  align-items: center;
  margin: 5px;

  .name {
    flex-shrink: 0;
    width: auto;
  }
}
</style>

